<div
  [ngClass]="{
    redesign: Redesign
  }"
>
  <div
    [ngClass]="
      isActive ? 'submit-box submit-active' : 'submit-box submit-disable'
    "
    id="submit-button"
    (click)="buttonClicked($event)"
    [@upDown]="show ? 'up' : 'down'"
  >
    <div class="submit-title">
      {{ title }}
    </div>
  </div>
</div>
